// Motion enhancements — ripple, save ribbon, scroll-fade observer.

// === Ripple effect on button clicks ===
function attachRipple() {
	document.addEventListener("click", (ev) => {
		const btn = ev.target.closest(".btn, button[type='button'], button[type='submit']");
		if (!btn || btn.disabled) return;
		// Skip our own buttons + dropdown toggles
		if (btn.classList.contains("e16-fab")) return;
		if (btn.classList.contains("e16-tbtn")) return;
		if (btn.classList.contains("e16-color-dot")) return;

		const rect = btn.getBoundingClientRect();
		const size = Math.max(rect.width, rect.height);
		const x = ev.clientX - rect.left - size / 2;
		const y = ev.clientY - rect.top - size / 2;

		const ripple = document.createElement("span");
		ripple.className = "e16-ripple";
		ripple.style.width = ripple.style.height = size + "px";
		ripple.style.left = x + "px";
		ripple.style.top = y + "px";

		btn.appendChild(ripple);
		setTimeout(() => ripple.remove(), 700);
	});
}

// === Save ribbon — sweeps across top of page on form save ===
function attachSaveRibbon() {
	if (!window.frappe) return;

	// Hook into Frappe's save event
	const originalAlert = window.frappe?.show_alert;
	if (!originalAlert) return;

	const showRibbon = () => {
		const existing = document.querySelector(".e16-save-ribbon");
		if (existing) existing.remove();
		const ribbon = document.createElement("div");
		ribbon.className = "e16-save-ribbon";
		document.body.appendChild(ribbon);
		setTimeout(() => ribbon.remove(), 900);
	};

	// Hook on jQuery if available
	const $ = window.jQuery || window.$;
	if ($) {
		$(document).on("after_save", showRibbon);
		// Listen for any successful form save event
		$(document).on("form_submit_success form_save_success", showRibbon);
	}

	// Hook generic frappe.realtime doc_update
	try {
		if (frappe.realtime) {
			frappe.realtime.on("doc_update", showRibbon);
		}
	} catch (e) {}
}

// === Smooth scroll to anchor ===
function attachSmoothScroll() {
	document.addEventListener("click", (ev) => {
		const a = ev.target.closest('a[href^="#"]');
		if (!a) return;
		const href = a.getAttribute("href");
		if (href === "#" || href.length < 2) return;
		const target = document.querySelector(href);
		if (!target) return;
		ev.preventDefault();
		target.scrollIntoView({ behavior: "smooth", block: "start" });
	});
}

// === Online indicator helpers ===
// Auto-mark current user's avatar as online
function markCurrentUserOnline() {
	try {
		const sel = ".dropdown-navbar-user .avatar, .navbar-user .avatar, .sidebar-user-button .avatar";
		document.querySelectorAll(sel).forEach((el) => el.classList.add("is-online"));
	} catch (e) {}
}

export const motion = {
	mount() {
		try { attachRipple(); } catch (e) { console.warn("[e16] ripple", e); }
		try { attachSaveRibbon(); } catch (e) { console.warn("[e16] ribbon", e); }
		try { attachSmoothScroll(); } catch (e) { console.warn("[e16] scroll", e); }

		setTimeout(markCurrentUserOnline, 1500);
		setTimeout(markCurrentUserOnline, 4000);

		try {
			if (frappe?.router) {
				frappe.router.on("change", () => setTimeout(markCurrentUserOnline, 600));
			}
		} catch (e) {}
	},
};
